import { useEffect, useRef, useState } from "react"
import { useGeneralHooks } from "../../../../../Hooks/hooks";
import { IBusinessProfileProps } from "./businessProfile"
import { BusinessProfileActionTypes, IBusinessprofileAction } from "../../../../../Interfaces/componentTypes";
import ProfileMainInfo from "./Contents/ProfileMain/profileMainInfo";
import ProfileGallery from "./Contents/Gallery/gallery";
import { Contact, EditData, Gallery, Preview } from "../../../../../Assets/Icons";
import BusinessContacts from "./Contents/Contacts/contacts";
import { VisitorPageContents } from "../../../../Visitor/Menu/visitorPage";

const useBusinessProfile = (props: IBusinessProfileProps) => {
    const { data, onUpdate } = props;
    const { t, largeScreen } = useGeneralHooks();
    const [activeContent, setActiveContent] = useState<BusinessProfileActionTypes>(BusinessProfileActionTypes.MAIN);
    const navRef = useRef<HTMLDivElement>(null);
    const navItemRefs = useRef<(HTMLDivElement | null)[]>([]);
    const scrollTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    const handleNavClick = (index: number, id: BusinessProfileActionTypes) => {
        if(id === BusinessProfileActionTypes.PREVIEW){
            window.open(`/${data.name!.replace(" ",'')}/menu/${data.id!}?tab=${VisitorPageContents.PROFILE}`, '_blank')
        }else{
            setActiveContent(id);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            const currentUrl = window.location.href.split('?')[0];
            window.history.pushState({}, '', `${currentUrl}?tab=${id}`);
    
            if (navItemRefs.current[index] && navRef.current && !largeScreen) {
                navItemRefs.current[index]?.scrollIntoView({
                    behavior: 'smooth',
                    inline: 'center',
                    block: 'nearest'
                });
            }
        }
    };

    const businessProfileActions: IBusinessprofileAction[] = [
        {
            id: BusinessProfileActionTypes.MAIN,
            title: t('My_Business.Main'),
            icon: EditData,
        },
        {
            id: BusinessProfileActionTypes.GALLERY,
            title: t('My_Business.Gallery'),
            icon: Gallery,
        },
        {
            id: BusinessProfileActionTypes.CONTACT,
            title: t('My_Business.Business_Profile.Contact.Title'),
            icon: Contact,
        },
        ...(data.business_profile ? [{
            id: BusinessProfileActionTypes.PREVIEW,
            title: t('My_Business.Preview'),
            icon: Preview,
        }] : [])
    ];

    useEffect(() => {
        scrollTop()
    }, [activeContent]);

    const PAGE_CONTENTS = {
        [BusinessProfileActionTypes.MAIN]: (
            <ProfileMainInfo
                data={data}
                onUpdate={onUpdate}
            />
        ),
        [BusinessProfileActionTypes.PREVIEW]: (
            <ProfileMainInfo
                data={data}
                onUpdate={onUpdate}
            />
        ),
        [BusinessProfileActionTypes.GALLERY]: (
            <ProfileGallery
                data={data}
                onUpdate={onUpdate}
            />
        ),
        [BusinessProfileActionTypes.CONTACT]: (
            <BusinessContacts
                data={data}
                onUpdate={onUpdate}
            />
        )
    };

    return {
        navRef,
        navItemRefs,
        activeContent,
        PAGE_CONTENTS,
        handleNavClick,
        businessProfileActions,
    }
};

export default useBusinessProfile;